module.exports = __webpack_public_path__ + "menu_1.e0f7a74e.png";